import css from './Button.module.scss';
import classNames from 'classnames';

export default function Button({ type, title, clickHandler }) {
    if (type === 'tiny') {
        return (
            <button onClick={clickHandler} className={classNames(css.button, css.buttonTiny, 'grow')}>
                <p className={classNames(css.buttonText, css.buttonTextTiny)}>{title}</p>
            </button>
        );
    }
    if (type === 'small') {
        return (
            <button onClick={clickHandler} className={classNames(css.button, css.buttonSmall, 'grow')}>
                <p className={classNames(css.buttonText, css.buttonTextSmall)}>{title}</p>
            </button>
        );
    }
    if (type === 'middle') {
        return (
            <button onClick={clickHandler} className={classNames(css.button, css.buttonMiddle, 'grow')}>
                <p className={classNames(css.buttonText, css.buttonTextMiddle)}>{title}</p>
            </button>
        );
    }
    return (
        <button onClick={clickHandler} className={classNames(css.button, 'grow')}>
            <p className={css.buttonText}>{title}</p>
        </button>
    );
}
